import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'
import { Box } from '@chakra-ui/react'

interface CustomIconProps extends IconProps {
  variant?: string
}

const DocumentOutline = createIcon({
  displayName: 'DocumentOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M8,13h8"></path>
        <path d="M8,17h8"></path>
        <path d="M6,3h9.172c0.53,0 1.039,0.211 1.414,0.586l2.828,2.828c0.375,0.375 0.586,0.884 0.586,1.414v11.172c0,1.105 -0.895,2 -2,2h-12c-1.105,0 -2,-0.895 -2,-2v-14c0,-1.105 0.895,-2 2,-2Z"></path>
        <path d="M20,8h-4c-0.552,0 -1,-0.448 -1,-1v-4"></path>
        <path d="M8,9h3"></path>
      </g>
      <path fill="none" d="M0,0h24v24h-24v-24Z"></path>
    </>
  ),
})

const DocumentTwoTone = createIcon({
  displayName: 'DocumentTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box as="g" strokeLinecap="round" strokeWidth="1.5" stroke="twoToneStrokeColor" fill="none" strokeLinejoin="round">
        <Box as="path" fill="blue" stroke="twoToneFillColor" d="M8,13h8"></Box>
        <Box as="path" fill="blue" stroke="twoToneFillColor" d="M8,17h8"></Box>
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          d="M6,3h9.172c0.53,0 1.039,0.211 1.414,0.586l2.828,2.828c0.375,0.375 0.586,0.884 0.586,1.414v11.172c0,1.105 -0.895,2 -2,2h-12c-1.105,0 -2,-0.895 -2,-2v-14c0,-1.105 0.895,-2 2,-2Z"
        ></Box>
        <Box as="path" fill="twoToneFillColor" stroke="twoToneStrokeColor" d="M20,8h-4c-0.552,0 -1,-0.448 -1,-1v-4"></Box>
        <Box as="path" stroke="twoToneFillColor" d="M8,9h3"></Box>
      </Box>
    </>
  ),
})

const Document: FC<CustomIconProps> = (props) => {
  if (props.variant === 'twoTone') return <CustomIcon as={DocumentTwoTone} {...props} />

  return <CustomIcon as={DocumentOutline} {...props} />
}

export default memo(Document)
